import { useNavigate } from 'react-router';
import Header from '/@/components/bayer/header';
import PageContainer from '/@/components/bayer/page-container';
import { _ } from '/@/locale';
import { reverse } from '/@/utils/router';
import CropProtectionWhenToApply from '../crop-protection/when-to-apply';

const CropProtectionWhenToApplyPage = () => {
    const navigate = useNavigate();
    return (
        <PageContainer
            header={
                <Header
                    title={_('Cuándo aplicar un fitosanitario según el cultivo')}
                    subtitle={_(
                        'Consultá el momento ideal de aplicación según la problemática y el estado del cultivo.'
                    )}
                    breadcrumbs={[
                        { label: _('Productos'), onClick: () => navigate(reverse('productExploration.main')) },
                        { label: _('Cuándo aplicar') },
                    ]}
                />
            }
        >
            <CropProtectionWhenToApply />
        </PageContainer>
    );
};

export default CropProtectionWhenToApplyPage;
